<tui-root>
  <router-outlet></router-outlet>

  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-ripple-multiple"
    [fullScreen]="true"
  >
    <p style="color: white">{{ 'common.actions.loading' | translate }}</p>
  </ngx-spinner>
</tui-root>
